// extracted by mini-css-extract-plugin
export default {"wrapper":"Sidebar_wrapper__8AdM3","body":"Sidebar_body__G4bli"};